import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

// import devRouter from './modules/devRouter';

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode , otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */
/**
 * 只有当route children.length大于等于1时，才会出现子菜单。
 * hidden: true                   当设置为true时隐藏菜单
 * alwaysShow: true               如果设置true 总是显示根菜单，如果不设置，超过1个子元素将会显示嵌套模式否则将不显示根目录
 * redirect: noredirect           如果设置noredirect在面包屑中将部会进行跳转
 * name:'router-name'             the name is used by <keep-alive> (必须设置!!!)
 * meta : {
    roles: ['admin','editor']    控制页面的角色 (可设置多个)
    title: 'title'               在菜单，面包屑显示 (推荐设置)
    icon: 'svg-name'             菜单中的图标
    noCache: true                如果设置true 页面将不进行缓存(default is false)
    affix: true                  如果设置true, 当在声明路由是 添加了 Affix 属性，则当前tag会被固定在 tags-view中（不可被删除）。
    breadcrumb: false            如果设置false,这个页面将隐藏在面包屑中(default is true)
    activeMenu: '/example/list'  如果设置了路径，菜单将高亮显示设置的路径
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 * constantRoutes 固定规则
 * 一个没有权限要求的基础页面
 * 所有角色都可以访问的
 */

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/sys',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'role_edit',
        component: () => import('@/views/role/edit'),
        name: 'RoleEdit',
        meta: { title: '角色编辑', icon: 'el-icon-user', noCache: true, activeMenu: '/system/role_list' },
        hidden: true
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/authRedirect'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/errorPage/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/errorPage/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'el-icon-s-home' }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: '个人信息', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/site-extra',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'space_date_price',
        component: () => import('@/views/site/space_date_price'),
        name: 'SpaceDatePrice',
        meta: {
          title: '特定日期价格',
          noCache: true
        }
      }
    ]
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 * 异步路由
 * 需要根据用户角色动态加载的路由
 */

// 需要创建三级情况下在二级加： component: {render(c) { return c('router-view') }},
export const asyncRoutes = [
  {
    path: '/system',
    component: Layout,
    redirect: '/system/role_list',
    name: 'System',
    meta: {
      title: '系统设置',
      icon: 'el-icon-s-tools',
      auth: ['System.browse']
    },
    children: [
      //   path: 'logList',
      //   component: () => import('@/views/system/log_list'),
      //   name: 'LogList',
      //   meta: { title: '操作日志', icon: 'el-icon-tickets', auth: ['LogList.browse'] }
      // },
      {
        path: 'role_list',
        component: () => import('@/views/role/list'),
        name: 'Role',
        meta: {
          title: '角色管理',
          icon: 'el-icon-user',
          auth: ['Role.browse', 'Role.create', 'Role.edit', 'Role.delete']
        }
      },
      {
        path: 'role_edit',
        component: () => import('@/views/role/edit'),
        name: 'RoleEdit',
        meta: { title: '角色编辑', icon: 'el-icon-user', noCache: true, activeMenu: '/system/role_list' },
        hidden: true
      },
      {
        path: 'account_list',
        component: () => import('@/views/system/account_list'),
        name: 'Account',
        meta: {
          title: '账户管理',
          icon: 'el-icon-s-custom',
          auth: ['Account.browse', 'Account.create', 'Account.edit', 'Account.delete', 'Account.reset_password']
        }
      },
      {
        path: 'menu_list',
        component: () => import('@/views/menu/index'),
        name: 'Menu',
        meta: {
          title: '菜单管理',
          icon: 'el-icon-s-operation',
          auth: []
        }
      },
      {
        path: 'department_list',
        component: () => import('@/views/department/index'),
        name: 'Department',
        meta: {
          title: '部门管理',
          icon: 'el-icon-office-building',
          auth: []
        }
      },
      {
        path: 'attachment_list',
        component: () => import('@/views/system/attachment_list'),
        name: 'Attachment',
        meta: {
          title: '素材中心',
          icon: 'el-icon-s-grid',
          auth: ['Attachment.browse', 'Attachment.create', 'Attachment.edit', 'Attachment.delete']
        }
      },
      {
        path: 'configure',
        component: () => import('@/views/configure/edit'),
        name: 'Configure',
        meta: { title: '网站信息', icon: 'el-icon-s-unfold', auth: ['Configure.browse'] }
      },
      {
        path: 'dict_type',
        component: () => import('@/views/system/dict_type'),
        name: 'DictType',
        meta: {
          title: '数据字典',
          icon: 'el-icon-s-grid',
          auth: ['DictType.browse', 'DictType.create', 'DictType.edit', 'DictType.delete']
        }
      },
      {
        path: 'dict_data',
        component: () => import('@/views/system/dict_data'),
        name: 'DictData',
        meta: {
          title: '字典数据',
          icon: 'el-icon-s-grid',
          auth: ['DictData.browse', 'DictData.create', 'DictData.edit', 'DictData.delete']
        }
      }
    ]
  },
  {
    path: '/utils',
    component: Layout,
    redirect: '/utils/generate',
    name: 'Utils',
    meta: {
      title: '系统工具',
      icon: 'el-icon-s-tools',
      auth: ['Utils.browse']
    },
    children: [
      {
        path: 'generate_list',
        component: () => import('@/views/generate/index'),
        name: 'Generate',
        meta: {
          title: '代码生成器',
          icon: 'el-icon-s-tools',
          auth: ['Generate.browse']
        }
      },
      {
        path: 'demo_list',
        component: () => import('@/views/demo/index'),
        name: 'ViewDemo',
        meta: {
          title: '表单类型演示',
          icon: 'el-icon-s-tools',
          auth: ['ViewDemo.browse', 'ViewDemo.create', 'ViewDemo.edit', 'ViewDemo.delete', 'ViewDemo.export', 'ViewDemo.import']
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    children: [
      {
        path: 'index',
        component: () => import('@/views/user/index'),
        meta: {
          icon: 'el-icon-picture-outline',
          title: '用户管理',
          auth: ['User.browse', 'User.create', 'User.edit', 'User.delete', 'User.details']
        },
        name: 'User'
      }
    ]
  },
  {
    path: '/banner',
    component: Layout,
    name: 'BannerSystem',
    meta: {
      title: 'Banner管理',
      icon: 'el-icon-picture-outline',
      auth: ['BannerSystem.browse']
    },
    children: [
      {
        path: 'banner',
        component: () => import('@/views/banner/index'),
        meta: {
          icon: 'el-icon-picture-outline',
          title: 'Banner',
          auth: ['Banner.browse', 'Banner.create', 'Banner.edit', 'Banner.delete']
        },
        name: 'Banner'
      }
    ]
  },
  {
    path: '/article',
    component: Layout,
    name: 'articleSystem',
    meta: {
      title: '文章管理',
      icon: 'el-icon-collection',
      auth: ['articleSystem.browse']
    },
    children: [
      {
        path: 'article',
        component: () => import('@/views/article/index'),
        meta: {
          icon: 'el-icon-collection',
          title: '文章管理',
          auth: ['Article.browse', 'Article.create', 'Article.edit', 'Article.delete']
        },
        name: 'Article'
      }
    ]
  },
  {
    path: '/partners',
    component: Layout,
    name: 'PartnersSystem',
    meta: {
      title: '合作伙伴',
      icon: 'el-icon-s-custom',
      auth: ['PartnersSystem.browse']
    },
    children: [
      {
        path: 'partners',
        component: () => import('@/views/partners/index'),
        meta: {
          icon: 'el-icon-s-custom',
          title: '合作伙伴',
          auth: ['Partners.browse', 'Partners.create', 'Partners.edit', 'Partners.delete']
        },
        name: 'Partners'
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
